import React from "react"
import { Group } from "@mantine/core"

import classes from "./PageFooter.module.css"

export const PageFooter = ({ children }) => {
    return (
        <Group position="center" spacing="sm" className={classes.container}>
            {children}
        </Group>
    )
}
